import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DevExtremeModule } from 'devextreme-angular';
import validationEngine from 'devextreme/ui/validation_engine';
import * as _ from 'lodash';
import moment from 'moment';
import { CdrUnitOfWork } from 'src/app/core/core.module';
import { Dumpster } from 'src/app/core/model/dumpster';
import { InvoiceLine } from 'src/app/core/model/invoice-line';
import { Job } from 'src/app/core/model/job';
import { QuickBooksProduct } from 'src/app/core/model/quick-books-product';
import { Rental } from 'src/app/core/model/rental';
import { BaseDialogComponent } from 'src/app/shared/base-dialog/base-dialog.component';

@Component({
    selector: 'app-invoice-line-dialog',
    standalone: true,
    templateUrl: './invoice-line-dialog.component.html',
    styleUrls: ['./invoice-line-dialog.component.scss'],
    imports: [FormsModule, DevExtremeModule]
})
export class InvoiceLineDialogComponent extends BaseDialogComponent<any> implements OnInit {
    customerId: number;
    invoiceLine: InvoiceLine;
    dumpsters: Dumpster[];
    rentals: Rental[];
    quickBooksProducts: QuickBooksProduct[];
    jobs: Job[];

    constructor(private uow: CdrUnitOfWork) {
        super();
    }

    async ngOnInit() {
        this.dumpsters = this.uow.lookups.dumpsters as Dumpster[];
        const actions = this.uow.lookups.actions;
        this.rentals = await this.uow.rentals.getActiveRentals({ customerId: this.customerId });
        this.quickBooksProducts = await this.uow.getQBProducts(true);

        if (this.invoiceLine.rentalId) {
            this.jobs = _.orderBy(await this.uow.jobs.getActiveJobsByRentalId(this.invoiceLine.rentalId), 'created', 'desc');
        }
    }

    onRentalChanged(e) {
        const rental = this.rentals.find(rental => rental.id === e.value);
        this.invoiceLine.service = rental?.dumpster.size ?? null;
        this.invoiceLine.rate = rental?.price ?? null;
    }

    save = async () => {
        const success = this.valid();
        if (!success) return;

        this.hide({ success: true, value: this.invoiceLine });
    };

    cancel = async () => {
        this.hide({ success: false });
    };

    valid() {
        const groupConfig = validationEngine.getGroupConfig('mainValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('mainValidationGroup');
            return result.isValid;
        } else return false;
    }

    displayJob(data: any): string {
        if (data) {
            return `J${data.id} - ${data.action.name}: ${moment(data.startDate).format('MM/DD/yyyy')}`;
        }
        return '';
    }
}
